import { Stripe, StripeElements } from "@stripe/stripe-js";
import { FormEvent } from "react";
import {captureException, captureMessage} from "../sentry";

const confirmStripeSetup =
  (
    stripe: Stripe | null,
    elements: StripeElements | null,
    successReturnUrl: string
  ) =>
  async (e?: FormEvent<HTMLFormElement>) => {
    e?.preventDefault();

    if (!stripe || !elements) {
      return;
    }

    try {
      const { error } = await stripe.confirmSetup({
        elements,
        confirmParams: {
          return_url: successReturnUrl,
        },
      });

      if (error) {
        captureMessage(`Stripe error: ${error.message}`, 'info');
      }

      return error;
    } catch (err) {
      captureException(err as Error, { context: 'confirmStripeSetup' });
      throw err;
    }
  };

const confirmStripePayment =
  (
    stripe: Stripe | null,
    elements: StripeElements | null,
    successReturnUrl: string
  ) =>
  async (e?: FormEvent<HTMLFormElement>) => {
    e?.preventDefault();

    if (!stripe || !elements) {
      return;
    }

    try {
      const { error } = await stripe.confirmPayment({
        elements,
        confirmParams: {
          return_url: successReturnUrl,
        },
      });

      if (error) {
        captureMessage(`Stripe error: ${error.message}`, 'info');
      }

      return error;
    } catch (err) {
      captureException(err as Error, { context: 'confirmStripePayment' });
      throw err;
    }
  };

export { confirmStripeSetup, confirmStripePayment };
